import React from "react";
import { InputLabel, OutlinedInput } from "@mui/material";
import FormSection from "../../Forms/FormSection/form-section";
import { DbUserGroupInfos } from "../../../Core/Api/Types/db-user-group-infos";
import { DbUserGroupRoleInfos } from "../../../Core/Api/Types/db-user-group-role-infos";
import { useTranslation } from "react-i18next";
import { timeSpanToMinutes } from "../../../Utils/helpers";

interface ConfigMediaShareInfosProps {
  groupInfos: DbUserGroupInfos | DbUserGroupRoleInfos;
  onSetGroupInfos?: (
    value: any,
    context:
      | "maxShareViewDays"
      | "maxShareViews"
      | "maxShareViewIPs"
      | "maxShareViewClipsNumber"
      | "maxShareViewClipsDuration"
      | "defaultShareViewDays"
      | "defaultShareViews"
      | "defaultShareViewIPs"
      | "defaultShareViewClipsNumber"
      | "defaultShareViewClipsDuration"
      | "defaultShareName"
  ) => void;
}

const ConfigMediaShareInfos: React.FC<ConfigMediaShareInfosProps> = (props) => {
  const { t } = useTranslation();
  const { groupInfos, onSetGroupInfos } = props;

  return (
    <FormSection title={t("form:section.title.mediaShareInfo")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("field:label.maxDays")}</InputLabel>
      <OutlinedInput
        value={groupInfos.maxShareViewDays}
        id={"maxShareViewDays"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "maxShareViewDays");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.maxViews")}</InputLabel>
      <OutlinedInput
        value={groupInfos.maxShareViews}
        id={"maxShareViews"}
        type={"number"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "maxShareViews");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.maxIPs")}</InputLabel>
      <OutlinedInput
        value={groupInfos.maxShareViewIPs}
        id={"maxShareViewIPs"}
        type={"number"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "maxShareViewIPs");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.maxNumberOfClips")}</InputLabel>
      <OutlinedInput
        value={groupInfos.maxShareViewClipsNumber}
        id={"maxShareViewClipsNumber"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "maxShareViewClipsNumber");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.maxClipDuration")}</InputLabel>
      <OutlinedInput
        value={timeSpanToMinutes(groupInfos.maxShareViewClipsDuration)}
        id={"maxShareViewClipsDuration"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "maxShareViewClipsDuration");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultDays")}</InputLabel>
      <OutlinedInput
        value={groupInfos.defaultShareViewDays}
        id={"defaultShareViewDays"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareViewDays");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultViews")}</InputLabel>
      <OutlinedInput
        value={groupInfos.defaultShareViews}
        id={"defaultShareViews"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareViews");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultIPs")}</InputLabel>
      <OutlinedInput
        value={groupInfos.defaultShareViewIPs}
        id={"defaultShareViewIPs"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareViewIPs");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultNumberOfClips")}</InputLabel>
      <OutlinedInput
        value={groupInfos.defaultShareViewClipsNumber}
        id={"defaultShareViewClipsNumber"}
        sx={{ width: "100%", mb: 2 }}
        type={"number"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareViewClipsNumber");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultClipDuration")}</InputLabel>
      <OutlinedInput
        value={timeSpanToMinutes(groupInfos.defaultShareViewClipsDuration)}
        id={"defaultShareViewClipsDuration"}
        type={"number"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareViewClipsDuration");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.defaultClipName")}</InputLabel>
      <OutlinedInput
        value={groupInfos.defaultShareName}
        id={"defaultShareName"}
        sx={{ width: "100%" }}
        type={"text"}
        onChange={(e) => {
          onSetGroupInfos && onSetGroupInfos(e, "defaultShareName");
        }}
      />
    </FormSection>
  );
};

export default ConfigMediaShareInfos;
